module.exports = __webpack_public_path__ + "static/media/collections-surface.0ab408b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections-surface.jpg
// module id = 1144
// module chunks = 37